import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowPromotions from '../components/promotions/ShowPromotions';
import {
  fetchDiscounts, fetchSalesChannels,
  clearAuthErrors, fetchPromotions, disablePromotion, clearPromotionsErrors
} from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  promotions: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class PromotionsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ''
    }
    autoBind(this);
  }
  // TODO: review this, why duplication on each Container - gabo
  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }
  componentWillMount() {
    this.props.dispatch(clearPromotionsErrors());
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.promotions.search && this.props.promotions.search.length > 0) {
      query.search = this.props.promotions.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/promotions', query });
    } else {
      const getLimit = { limit: 1000 };
      this.props.dispatch(fetchPromotions(query));
      this.props.dispatch(fetchSalesChannels(getLimit));
      this.props.dispatch(fetchDiscounts(getLimit));
    }
  }
  onPromotionDisable(data) {
    this.props.dispatch(disablePromotion(data));
    this.props.dispatch(fetchPromotions(this.props.query));
  }
  handleChange(e) {
    this.setState({
      search: e.target.value
    })
  }
  handleSearchChange(e) {
    e.preventDefault()
    const { search } = this.state
    const promotions = this.props.promotions;
    const query = this.props.query;
    const router = this.props.router;
    const nextName = search;
    promotions.search = nextName;
    this.setState({
      promotions,
    })
    if (search && search.length) {
      query.search = nextName;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/promotions', query });
    this.props.dispatch(fetchPromotions(query));
  }
  navigation(route) {
    // add search to url
    this.props.dispatch(fetchPromotions(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="promotion component" style={authPage}>
        <h2>Promotions</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to={'/promotions/new'}>
              <RaisedButton
                label="Add New Promotion"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
          <form onSubmit={this.handleSearchChange}>
            <TextField
              floatingLabelText="Search by Name/Code"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              // value={this.props.promotions.search}
              onChange={this.handleChange}
              name='search'
            />
            <RaisedButton type='submit' primary tabIndex={-1}> Search </RaisedButton>
            </form>
            <Pagination
              paginationInfo={this.props.promotions.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowPromotions
            promotions={this.props.promotions}
            onPromotionDisable={data => this.onPromotionDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.promotions.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

PromotionsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

PromotionsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    promotions: state.promotions,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(PromotionsPage));



// WEBPACK FOOTER //
// ./src/containers/PromotionsPage.js